// @ts-nocheck

import PropTypes from 'prop-types';
import { useEffect, useCallback } from 'react';

import { Target } from '../../client';

const PageSelectTab = ({ tab = 'home' }) => {
  const highlightSubMenu = useCallback((value) => {
    const { highlightMenu } = window;
    if (typeof highlightMenu === 'function') {
      highlightMenu(value);
    }
  }, []);

  const highlightMenu = useCallback((value) => {
    const { highlightMainMenu } = window;
    if (typeof highlightMainMenu === 'function') {
      highlightMainMenu(value);
    }
  }, []);

  useEffect(() => {
    if (tab === 'grids') {
      highlightMenu(tab);
      highlightSubMenu('none');
    } else {
      highlightMenu('sport-betting');
      highlightSubMenu(tab);
    }
  }, [highlightMenu, highlightSubMenu, tab]);

  return null;
};

if (Target.__ENV__ !== 'production') {
  PageSelectTab.propTypes = {
    tab: PropTypes.string,
  };
}

export default PageSelectTab;
